'use strict';

// Pure URL policy: no configuration loading, network requests or runtime services.
const MEDIA_ORIGIN = 'https://media.ecotourodisha.com';
const MAIN_HOSTS = new Set([
  'kindspear-mr-suitev3.sgp1.digitaloceanspaces.com',
  'kindspear-mr-suitev3.sgp1.cdn.digitaloceanspaces.com',
  'kindspear-mr-suitev2.sgp1.digitaloceanspaces.com',
  'kindspear-mr-suitev2.sgp1.cdn.digitaloceanspaces.com',
]);
const LEGACY_HOSTS = new Set([
  'teceads.sgp1.digitaloceanspaces.com',
  'teceads.sgp1.cdn.digitaloceanspaces.com',
]);
const SIGNED_QUERY = /(?:x-amz-|x-goog-|signature|awsaccesskeyid|key-pair-id|(?:^|[?&])(?:token|policy|sig)=)/i;

function parseMediaUrl(value) {
  if (typeof value !== 'string' || !/^https?:\/\//i.test(value)) return null;
  try {
    const url = new URL(value);
    if (url.username || url.password || url.port || SIGNED_QUERY.test(url.search)) return null;
    let namespace;
    let path = url.pathname;
    if (MAIN_HOSTS.has(url.hostname)) namespace = 'main';
    else if (LEGACY_HOSTS.has(url.hostname)) namespace = 'legacy';
    else if (url.origin === MEDIA_ORIGIN) {
      namespace = path.startsWith('/legacy/teceads/') ? 'legacy' : 'main';
      if (namespace === 'legacy') path = path.slice('/legacy/teceads'.length);
    } else return null;
    // Originals are authenticated storage objects, never public delivery URLs.
    if (/^\/media\/[^/]+\/v[^/]+\/source\//i.test(decodeURIComponent(path))) return null;
    return { url, namespace, path };
  } catch { return null; }
}

function normalizePublicMediaUrl(value, publicBase = '') {
  if (!publicBase) return value;
  const parsed = parseMediaUrl(value);
  if (!parsed) return value;
  const base = new URL(publicBase);
  if (base.protocol !== 'https:' || base.username || base.password || base.search || base.hash || base.port) {
    throw new Error('Public media base must be a plain HTTPS URL');
  }
  const prefix = parsed.namespace === 'legacy' ? '/legacy/teceads' : '';
  // URL.pathname retains percent encoding. Never decode/re-encode object names.
  const objectPath = parsed.path === '/' && !parsed.url.search && !parsed.url.hash ? '' : parsed.path;
  return `${base.href.replace(/\/$/, '')}${prefix}${objectPath}${parsed.url.search}${parsed.url.hash}`;
}

function publicMediaIdentity(value) {
  const parsed = parseMediaUrl(value);
  return parsed ? `${parsed.namespace}:${parsed.path}${parsed.url.search}${parsed.url.hash}` : value;
}

function normalizePublicMediaValue(value, publicBase = '') {
  if (!publicBase) return value;
  if (typeof value === 'string') return normalizePublicMediaUrl(value, publicBase);
  if (Array.isArray(value)) return value.map(item => normalizePublicMediaValue(item, publicBase));
  if (!value || Object.getPrototypeOf(value) !== Object.prototype) return value;
  return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, normalizePublicMediaValue(item, publicBase)]));
}

module.exports = { MEDIA_ORIGIN, MAIN_HOSTS, LEGACY_HOSTS, SIGNED_QUERY, parseMediaUrl,
  normalizePublicMediaUrl, publicMediaIdentity, normalizePublicMediaValue };
